import { array } from 'fp-ts';
import { ContentSection, Dash, DividerList, LabeledListItem, TooltippedTag } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { ProductOptions, ProductPromotions } from '@mews-commander/data-access';
import { Stack } from '@optimus-web/core';
import { useActiveAccountingCategories } from '../../queries/useActiveAccountingCategories';
import { useAllowancesGet } from '../../queries/useAllowancesGet';
import { FlagTags } from './OptionsTabContent';

interface Props {
    allowanceId: string;
}
export const AllowanceOptionsTabContent = ({ allowanceId }: Props) => {
    const { consumableAccountingCategoryIds, options, promotions } = useAllowancesGet({ allowanceId });

    const activeAccountingCategories = useActiveAccountingCategories();
    const consumableAccountingCategories = activeAccountingCategories.filter(({ id }) =>
        consumableAccountingCategoryIds.includes(id)
    );

    return (
        <ContentSection title={lt('Options')}>
            <DividerList>
                <LabeledListItem
                    label={lt('AllowanceDetailOptionsSectionLabelPermittedAllowance')}
                    itemAlignment="start"
                >
                    <Stack spacing="100" wrap>
                        {array.isNonEmpty(consumableAccountingCategories) ? (
                            consumableAccountingCategories.map(({ id, name }) => (
                                <TooltippedTag key={id} tooltip={name} variant="basicSubtle" outline>
                                    {name}
                                </TooltippedTag>
                            ))
                        ) : (
                            <Dash />
                        )}
                    </Stack>
                </LabeledListItem>
                <LabeledListItem
                    label={lt('ProductOptions')}
                    labelOptions={{ whiteSpace: 'nowrap' }}
                    itemAlignment="start"
                >
                    <FlagTags<ProductOptions> flagName="ProductOptions" flagValues={options} />
                </LabeledListItem>
                <LabeledListItem label={lt('Promotions')} itemAlignment="start">
                    <FlagTags<ProductPromotions> flagName="ProductPromotions" flagValues={promotions} />
                </LabeledListItem>
            </DividerList>
        </ContentSection>
    );
};
